import React from 'react';
import {Accion} from '../comun/Index';
import './estilos.css';
import axios from 'axios';

const getFecha = function(fecha, hora = false){
  const fechaN = new Date(fecha);
  const fechaTexto = fechaN.toLocaleDateString('es-AR');
  const horaTexto = fechaN.toLocaleTimeString('es-AR');
  let cadena = fechaTexto;
  if (hora) cadena += ' ' + horaTexto;
  return cadena
}

const getDetalles = function(persona_id){
    return new Promise(function(resolve, reject) {
      const url = localStorage.getItem('apiUrl') + '/personas/agente/detalles';
      const config = {
        headers:{authorization:sessionStorage.getItem('token')},
        params:{persona_id}
      };
      console.log(config)
      axios.get(url, config)
      .then((res) => resolve(res.data.persona))
      .catch((error) => reject(error));
    });
  }

const estados = [
  {id:1, descripcion:'Observado'},
  {id:2, descripcion:'Derivado'},
  {id:3, descripcion:'Parcial'},
  {id:4, descripcion:'Finalizado'}
]

export default class Listado extends React.Component {
  constructor(props) {
    super(props);
    this.state={
      expandir:null,
      detalles:null,
      loading:false
    }
  }

  expandir(persona_id){
    const {expandir} = this.state;
    if (expandir !== persona_id){
      this.detalles(persona_id);
      this.setState({expandir:persona_id});
    } else {
      this.setState({detalles:null,expandir:null});
    }
  }
  
  detalles(persona_id){
    this.setState({loading:true})
    getDetalles(persona_id)
    .then((detalles) => this.setState({loading:false, detalles}))
    .catch((error) => {
      alert("Ocurrió un error");
      console.log(error);
    })
  }

  // getEstado(estado_id){
  //   const estado = estados.find((item, index) => item.id == estado_id).descripcion;
  //   return(estado);
  // }

  render(){
    const {expandir,detalles,loading} = this.state;
    const {personas} = this.props;
    return(
      <div className="Lista">
        {personas?.length > 0 && personas.map((item, index) => {
          return(
            <div
              key={index}
              className="Item"
              style={{backgroundColor:index%2===1?'#e3e3e3':'#f0f0f0'}}
            >
              <div className="Detalles">
                <div style={{display:'flex', flexDirection:'row', alignItems:'flex-end'}}>
                  <Accion
                    icono={expandir === index ? 'keyboard_arrow_up': 'keyboard_arrow_down'}
                    ayuda="Expandir"
                    backgroundColor="lightgrey"
                    disabled={false}
                    onClick={() => this.expandir(item.id)}
                  />
                  {`${item.documento} - ${item.apellidos}, ${item.nombres}`}
                </div>
              </div>
              {expandir === item.id &&
                <div className="Preguntas">
                  {detalles !== null && 
                    <>
                      <div style={{display:'flex', flexDirection:'column'}}>
                        <span style={{fontSize:18}}>Oficios</span>
                        {detalles.oficios?.length > 0 && detalles.oficios.map((oficio, index) => {
                          return(
                            <li key={index} >
                              {`(${oficio.id}) Oficio N°${oficio.numero} - Exp ${oficio.numero_exp}/${oficio.anio_exp}   - `} <b> {oficio.caratula} </b> {`- ${oficio.juzgado.nombre} Distrito: ${oficio.juzgado.distrito} - ${oficio.juzgado.localidad} `}
                              <br/>
                              {`Ultimo pase: ${getFecha(oficio.ultimo_pase.fecha, true)} - ${oficio.ultimo_pase.area} - ${oficio.ultimo_pase.estado} - ${oficio.ultimo_pase.observaciones}`}
                            </li>
                          )
                        })}
                      </div>
                    </>
                  }
                  {(detalles === null && loading) && 
                    <span>Cargando...</span>
                  }
                </div>
              }
            </div>
          )
        })}
      </div>
    );
  }

}
